import { render, staticRenderFns } from "./Solicitation.vue?vue&type=template&id=08169d0b&scoped=true"
import script from "./Solicitation.vue?vue&type=script&lang=js"
export * from "./Solicitation.vue?vue&type=script&lang=js"
import style0 from "./Solicitation.vue?vue&type=style&index=0&id=08169d0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08169d0b",
  null
  
)

export default component.exports